import * as z from "zod/v4";

export const ContentTypeSchema = z.enum([
  "UNSPECIFIED",
  "PRODUCT",
  "PRODUCT_GROUP",
  "ORDER_ID",
  "ORDER_NAME",
  "ORDER_NUMBER",
]);
export type ContentType = z.infer<typeof ContentTypeSchema>;

export const ProductIdentifierSchema = z.enum([
  "UNSPECIFIED",
  "PRODUCT_ID",
  "PRODUCT_SKU",
  "VARIANT_ID",
]);
export type ProductIdentifier = z.infer<typeof ProductIdentifierSchema>;

const CtidSchema_ = z.object({
  id: z.string(),
  userCreated: z.boolean(),
  selected: z.boolean(),
});
export const CtidSchema: z.ZodType<Ctid> = CtidSchema_;
export interface Ctid extends z.infer<typeof CtidSchema_> {}

const GoogleAdsCtidsSchema_ = z.object({
  ctids: z.record(z.string(), CtidSchema),
});
export const GoogleAdsCtidsSchema: z.ZodType<GoogleAdsCtids> =
  GoogleAdsCtidsSchema_;
export interface GoogleAdsCtids extends z.infer<typeof GoogleAdsCtidsSchema_> {}

const IntegrationMetadataSchema_ = z.object({
  contentType: ContentTypeSchema,
  productIdentifier: ProductIdentifierSchema,
  googleAdsCtids: GoogleAdsCtidsSchema.optional(),
});
export const IntegrationMetadataSchema: z.ZodType<IntegrationMetadata> =
  IntegrationMetadataSchema_;
export interface IntegrationMetadata
  extends z.infer<typeof IntegrationMetadataSchema_> {}
